import {
  balbrigganCoords,
  moorockCoords,
  oranmoreCoords,
  pecanSquareCoords,
  pecanSquareTestSiteCoords,
  walesCoords
} from '../../../../../constants/index';

export const supportedLocations = [
  {
    key: 'oranmore',
    name: 'Oranmore',
    coords: oranmoreCoords,
    type: 'production'
  },
  {
    key: 'testsite1',
    name: 'Moorock',
    coords: moorockCoords,
    type: 'test'
  },
  {
    key: 'testsite2',
    name: 'Parke Davis',
    coords: walesCoords,
    type: 'test'
  },
  {
    key: 'balbriggan',
    name: 'Balbriggan',
    coords: balbrigganCoords,
    type: 'production'
  },
  {
    key: 'pecan_square',
    name: 'Pecan Square',
    coords: pecanSquareCoords,
    type: 'production'
  },
  {
    key: 'pecan_square_test_site',
    name: 'Pecan Square test site',
    coords: pecanSquareTestSiteCoords,
    type: 'production'
  }
];

export const displayStatuses = [
  'ACCEPTED',
  'STORE_PREPARED',
  'DISPATCHED',
  'PREPARED',
  'READY',
  'STORE_ACCEPTED',
  'PREPARING'
];
